import { CommonModule, CurrencyPipe, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { TFMService } from 'app/mock-api/tfm.service';
import { CapturePaymentComponent } from '../capture-payment-dialog/capture-payment-dialog.component';
import { AdjustmentComponent } from '../adjustment-dialog/adjustment-dialog.component';
import { ViewQuotePaxComponent } from '../view-quote-pax/view-quote-pax.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { StayListDialogComponent } from '../list-stay-dialog/stay-list-dialog.component';
import { ActivityListDialogComponent } from '../list-activity-dialog/activity-list-dialog.component';
import { TransferListDialogComponent } from '../list-transfer-dialog/transfer-list-dialog.component';
import { QuoteViewDialogComponent } from '../quote-view/quote-view-dialog.component';
import { QuoteDetailsDialogComponent } from '../quote-details-dialog/quote-details-dialog.component';
import { AddServiceItemDialogComponent } from '../add-service-item-dialog/add-service-item-dialog.component';
import { ReserveDialogComponent } from '../reserve-dialog/reserve-dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { CommissionchangeDialogComponent } from '../commissionchange-dialog/commissionchange-dialog.component';
import { ServiceItemCancelComponent } from '../service-item-cancel/service-item-cancel.component';
import { ServiceItemRemoveComponent } from '../service-item-remove/service-item-remove.component';
import { CaptureConfirmationComponent } from '../capture-confirmation/capture-confirmation.component';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { WhatsappViewDialogComponent } from '../whatsapp-view-dialog/whatsapp-view-dialog.component';
import { BookconfirmationmodalComponent } from '../bookconfirmationmodal/bookconfirmationmodal.component';
import { UnreservebookingmodalComponent } from '../unreservebookingmodal/unreservebookingmodal.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { firstValueFrom } from 'rxjs';
import { InvoiceViewDialogComponent } from '../invoice-view/invoice-view-dialog.component';
import { ActivityAccommodationDialogComponent } from '../activity-accommodation-dialog/activity-accommodation-dialog.component';

@Component({
  selector: 'app-quote-list',
  standalone: true,
  imports: [CommonModule, DatePipe, NgFor, NgIf, CurrencyPipe, MatIconModule, MatTooltipModule, MatCheckboxModule, NgClass, MatMenuModule, MatButtonModule, MatIconModule, MatDividerModule],
  templateUrl: './quote-list.component.html',
  styleUrl: './quote-list.component.scss'
})
export class QuoteListComponent {
  @Output() refreshCart = new EventEmitter<void>();
  @Input() _view: any
  @Input() quotes: any;
  @Input() displayIcons: boolean = false;
  @Input() isReviewDrawerVisible: boolean = true;
  /** When true (e.g. on trips/review page), keeps review UI visible and ignores cart drawer toggle */
  @Input() lockReviewMode: boolean = false;
  @Input() showViewAllPax: boolean = true;
  /** When true (e.g. on search result screen), show only Supplier, Service, Dates and Sell (today's ROE) columns */
  @Input() compactColumns: boolean = false;
  // @Input() tripPoints: any; 
  @Input() isClient: boolean = this._tfmService.view.isClient;
  // @Input() itin: any;


  //@Output() viewQuote = new EventEmitter<any>();
  //@Output() selectQuote = new EventEmitter<{ checked: boolean, quote: any }>(); 

  public view: any = {};
  user: any;
  LoggedInUser: any;
  showRoeCostDetails = false;

  /** Display currency code (e.g. ZAR, NAD for site 72). From view.site when set by parent. */
  get displayCurrencyCode(): string {
    return this.view?.site?.displayCurrencyCode || this.view?.site?.currency?.code || 'ZAR';
  }
  private roeCostVisibilityResolved = false;
  private readonly roeDetailChannels = new Set(['andgo', 'and go', 'anddo', 'on holiday', 'onholiday', 'on-holiday']);

  // Cache for supplier extras/discounts (keyed by supplierID)
  private _supplierExtrasCache = new Map<number, any[]>();
  private _supplierDiscountsCache = new Map<number, any[]>();
  private _supplierDataRequested = new Set<number>();

  constructor(private _tfmService: TFMService, private dialog: MatDialog, private _tfmCartService: TFMCartService, private _cd: ChangeDetectorRef) {
    this.view = this._view || {};

    this.view.tripChange$ = this._tfmCartService.tripChange.subscribe(res => {
      this.view.trip = res;

      this._tfmService.saveLocalStorage("trip", this.view.trip);

      // this._tfmService.log('cart tripChange', this.view);
    });

    this._tfmCartService.cartViewToggle.subscribe(res => {
      this._tfmService.log("cart outside toggle", res);
      if (!this.lockReviewMode) {
        this.isReviewDrawerVisible = res;
      }
      if (res) {
        this.view.mode = 'review';
      }
      else {
        this.view.mode = 'summary';
      }

      this._cd.detectChanges();
    });
  }

  ngOnInit() {
    this.init();
  }

  public init() {
    if (this._view) {
      this.view = this._view;
    }
    if (!this.roeCostVisibilityResolved) {
      this.roeCostVisibilityResolved = true;
      this.resolveRoeCostVisibility();
    }
    this._tfmService.getLoggedInUser().subscribe(res => {
      this.LoggedInUser = res;
    });

    console.log("Quotes", this.quotes);
    console.log("VIEW", this.view);
    // if (this.quotes)
    //   for (const item of this.quotes.content) {
    //     const guid = item.itinerary.guid;
    //     console.log('Itenerary Guid',guid);
    //   }
    //     // this.view.quotesAll = this.quotes.content.map(item => `guids=${item.itinerary.guid}`).join("&");

    if (this.quotes && this.quotes.content) {
      for (const item of this.quotes.content) {
        const guid = item.itinerary.guid;
        console.log('Itinerary Guid', guid);
        this.getItinItems(item);
      }
      this.view.quotesAll = this.quotes.content.map(item => `guids=${item.itinerary.guid}`).join("&");
    }
    this.view.cart = this._tfmCartService.getCart();
  }
  ngOnChanges() {
    if (this._view) {
      this.view = this._view;
    }
    this.init();
    console.log('Check this View', this.quotes);
  }
  /**
 * Returns quotes that are reserved (status == 3)
 * These will be displayed first with special styling
 */
  getReservedQuotes(): any[] {
    const quotes = this.getNormalizedQuotes();
    return quotes.filter((quote) => quote.itinerary && quote.itinerary.status === 3);
  }

  /**
   * Returns quotes that are NOT reserved (status != 3)
   * These will be displayed after reserved quotes
   */
  getRegularQuotes(): any[] {
    const quotes = this.getNormalizedQuotes();
    const regular = quotes.filter((quote) => quote.itinerary && quote.itinerary.status !== 3);
    if (regular.length === 0) {
      return quotes;
    }
    return regular;
  }

  private getNormalizedQuotes(): any[] {
    const content = this.quotes?.content;
    if (Array.isArray(content)) {
      return content.map((quote) => this.normalizeQuote(quote));
    }
    if (content) {
      return [this.normalizeQuote(content)];
    }
    return [];
  }

  private normalizeQuote(quote: any): any {
    if (quote?.itinerary) {
      return quote;
    }

    return {
      ...quote,
      itinerary: quote
    };
  }

  public viewInvoice(quote, settings = null) {
    this.openModal(null, 'invoice', quote, settings);
  }

  public viewQuote(quote) {
    this.openModal(null, 'quote', quote);
  }

  public viewWhatsApp(quote) {
    this.openModal(null, 'whatsapp', quote);
  }

  selectQuote(state, quote) {
    quote.selected = state;

    this.view.quotesSelected = this.quotes.content.filter(x => x.selected).map(item => `guids=${item.itinerary.guid}`).join("&");
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  getStatusLabel(status: number): string {
    const resolver = this._view?.getStatusText || this.view?.getStatusText;
    if (typeof resolver === 'function') {
      return resolver(status);
    }

    const statusInfo = this._tfmService.getItinStatus(status);
    return statusInfo?.name || 'Unknown';
  }

  getStatusClass(status: number): string {
    const label = this.getStatusLabel(status).toLowerCase();

    if (label === 'draft') {
      return 'option-status-chip--draft';
    }
    if (label === 'pending' || label === 'in progress' || label === 'on hold') {
      return 'option-status-chip--hold';
    }
    if (label === 'confirmed' || label === 'approved' || label === 'completed') {
      return 'option-status-chip--confirmed';
    }
    if (label === 'cancelled') {
      return 'option-status-chip--cancelled';
    }

    return 'option-status-chip--draft';
  }

  isInProgressStatus(status: number): boolean {
    const label = this.getStatusLabel(status).toLowerCase();
    return label === 'in progress' || label === 'in process';
  }

  shouldShowStatusChip(status: number): boolean {
    const label = this.getStatusLabel(status).toLowerCase();
    if (label === 'new') {
      return false;
    }
    return !this.isInProgressStatus(status);
  }

  getPaxCount(quote: any): number | null {
    const itinerary = quote?.itinerary ?? quote?.content?.itinerary;
    if (!itinerary) {
      return null;
    }

    const pax = Number(itinerary.pax);
    if (Number.isFinite(pax) && pax > 0) {
      return pax;
    }

    const adults = Number(itinerary.adults);
    const teens = Number(itinerary.teens);
    const children = Number(itinerary.children);
    const infants = Number(itinerary.infants);

    const total =
      (Number.isFinite(adults) ? adults : 0) +
      (Number.isFinite(teens) ? teens : 0) +
      (Number.isFinite(children) ? children : 0) +
      (Number.isFinite(infants) ? infants : 0);

    return total > 0 ? total : null;
  }

  private normalizePaxCount(value: any): number {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) {
      return 0;
    }
    return parsed;
  }

  private getItineraryPax(quote: any): { adult: number; teen: number; child: number; infant: number; total: number } | null {
    const itinerary = quote?.itinerary ?? quote?.content?.itinerary;
    if (!itinerary) {
      return null;
    }

    const adults = this.normalizePaxCount(itinerary.adults);
    const teens = this.normalizePaxCount(itinerary.teens);
    const children = this.normalizePaxCount(itinerary.children);
    const infants = this.normalizePaxCount(itinerary.infants);
    const paxTotal = this.normalizePaxCount(itinerary.pax);
    const sum = adults + teens + children + infants;

    if (paxTotal === 0 && sum === 0) {
      return null;
    }

    let normalizedAdults = adults;
    let total = sum;

    if (paxTotal > 0) {
      const nonAdult = teens + children + infants;

      if (sum === 0) {
        normalizedAdults = paxTotal;
        total = paxTotal;
      } else if (nonAdult <= paxTotal) {
        normalizedAdults = Math.max(0, paxTotal - nonAdult);
        total = paxTotal;
      } else {
        total = sum;
      }
    }

    return {
      adult: normalizedAdults,
      teen: teens,
      child: children,
      infant: infants,
      total
    };
  }

  hasCapturedPax(quote: any): boolean {
    return (this.getPaxCount(quote) ?? 0) > 0;
  }

  isFlightItem(item: any): boolean {
    if (!item) {
      return false;
    }

    const typeCandidates = [
      item?.type,
      item?.serviceType,
      item?.item?.type,
      item?.item?.serviceType
    ];

    if (typeCandidates.some((type) => typeof type === 'string' && type.toLowerCase() === 'flight')) {
      return true;
    }

    return Boolean(
      item?.originDestinationOptions ||
      item?.item?.originDestinationOptions ||
      item?.flightSegments ||
      item?.item?.flightSegments
    );
  }

  isTransferItem(item: any): boolean {
    if (!item) {
      return false;
    }

    const typeCandidates = [
      item?.type,
      item?.serviceType,
      item?.item?.type,
      item?.item?.serviceType
    ];

    if (typeCandidates.some((type) => typeof type === 'string' && type.toLowerCase().includes('transfer'))) {
      return true;
    }

    const labelCandidates = [
      item?.supplier,
      item?.service,
      item?.serviceDescription,
      item?.title,
      item?.item?.supplier,
      item?.item?.service,
      item?.item?.serviceDescription,
      item?.item?.title
    ];

    return labelCandidates.some((value) => typeof value === 'string' && value.toLowerCase().includes('transfer'));
  }

  getFareSource(item: any): string | null {
    const candidates = [
      item?.fareSource,
      item?.provider,
      item?.source,
      item?.ticketingVendor,
      item?.ticketingVendorName,
      item?.office,
      item?.item?.fareSource,
      item?.item?.provider,
      item?.item?.source,
      item?.item?.ticketingVendor,
      item?.item?.ticketingVendorName,
      item?.item?.office,
      item?.item?.ticketingInfo?.ticketingVendor?.companyShortName
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : null;
  }

  isActivityItem(item: any): boolean {
    if (!item) {
      return false;
    }

    const typeCandidates = [
      item?.type,
      item?.serviceType,
      item?.item?.type,
      item?.item?.serviceType
    ];

    return typeCandidates.some((type) => typeof type === 'string' && type.toLowerCase() === 'activity');
  }

  isAdjustmentItem(item: any): boolean {
    if (!item) {
      return false;
    }

    const typeCandidates = [
      item?.type,
      item?.serviceType,
      item?.item?.type,
      item?.item?.serviceType
    ];

    if (typeCandidates.some((type) => typeof type === 'string' && type.toLowerCase() === 'adjustment')) {
      return true;
    }

    return Boolean(
      item?.index === 99 ||
      item?.serviceSelected ||
      item?.internalNote ||
      item?.item?.internalNote
    );
  }

  getAdjustmentSupplierLabel(item: any): string {
    const candidates = [
      item?.supplier,
      item?.serviceSelected,
      item?.service,
      item?.item?.supplier,
      item?.item?.serviceSelected,
      item?.item?.service
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : 'Select type';
  }

  getAdjustmentServiceLabel(item: any): string {
    const candidates = [
      item?.internalNote,
      item?.note,
      item?.notes,
      item?.comment,
      item?.item?.internalNote,
      item?.item?.note,
      item?.item?.notes,
      item?.item?.comment
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : 'Enter Note';
  }

  getProvidersLabel(item: any): string | null {
    if (this.isTransferItem(item)) {
      return null;
    }

    const candidates = [
      item?.payableSupplier,
      item?.payableSupplierId,
      item?.providerID,
      item?.providerId,
      item?.providers,
      item?.source,
      item?.ticketingVendorName,
      item?.ticketingVendor,
      item?.item?.payableSupplier,
      item?.item?.payableSupplierId,
      item?.item?.providerID,
      item?.item?.providerId,
      item?.item?.providers,
      item?.item?.source,
      item?.item?.ticketingVendorName,
      item?.item?.ticketingVendor,
      item?.item?.ticketingInfo?.ticketingVendor?.companyShortName
    ];

    for (const candidate of candidates) {
      if (Array.isArray(candidate)) {
        const cleaned = candidate
          .map((entry) => {
            if (typeof entry === 'string') {
              return entry.trim();
            }
            if (typeof entry === 'number') {
              return String(entry);
            }
            if (entry && typeof entry === 'object') {
              if (entry.id != null) {
                return String(entry.id);
              }
              if (entry.name) {
                return String(entry.name).trim();
              }
            }
            return '';
          })
          .filter((entry) => entry.length > 0);
        if (cleaned.length > 0) {
          return cleaned.join(', ');
        }
      }
      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        return candidate.trim();
      }
      if (typeof candidate === 'number') {
        return String(candidate);
      }
    }

    return null;
  }

  getBookingCode(item: any): string | null {
    const candidates = [
      item?.bookingCode,
      item?.BookingCode,
      item?.booking_code,
      item?.item?.bookingCode,
      item?.item?.BookingCode
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : null;
  }

  getCodeLabel(item: any): string | null {
    if (this.isTransferItem(item)) {
      return null;
    }

    const candidates = [
      item?.code,
      item?.serviceCode,
      item?.supplierCode,
      item?.item?.code,
      item?.item?.serviceCode,
      item?.item?.supplierCode
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : null;
  }

  getDepartureCountdown(itinerary: any): string | null {
    const departDate = this.toDate(
      itinerary?.departDate ??
      itinerary?.departureDate ??
      itinerary?.startDate ??
      itinerary?.start
    );
    if (!departDate) {
      return null;
    }

    const now = new Date();
    const diffMs = departDate.getTime() - now.getTime();
    if (diffMs <= 0) {
      return null;
    }

    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays >= 45) {
      const months = Math.ceil(diffDays / 30.4375);
      return `in ${months} month${months === 1 ? '' : 's'}`;
    }
    if (diffDays >= 14) {
      const weeks = Math.ceil(diffDays / 7);
      return `in ${weeks} week${weeks === 1 ? '' : 's'}`;
    }
    return `in ${diffDays} day${diffDays === 1 ? '' : 's'}`;
  }

  getServiceLabel(item: any): string {
    const candidates = [
      item?.service,
      item?.serviceDescription,
      item?.title,
      item?.description,
      item?.item?.service,
      item?.item?.serviceDescription,
      item?.item?.title,
      item?.item?.name,
      item?.name,
      item?.supplierDescription
    ];

    const match = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return match ? match.trim() : '';
  }

  getServiceTotals(quote: any): {
    grossCost: number;
    discount: number;
    netCost: number;
    baseCost: number;
    profit: number;
    sell: number;
    sellTodayRoe?: number;
    consultantCommission: number;
    agentCommission: number;
  } {
    const items = quote?.items?.content || [];

    return items.reduce(
      (acc, item) => {
        acc.grossCost += this.getGrossCost(item);
        acc.discount += this.getDiscount(item);
        acc.netCost += this.getNetCost(item);
        acc.baseCost += this.getBaseCost(item);
        acc.profit += this.getProfit(item);
        acc.sell += this.getSell(item);
        acc.sellTodayRoe = (acc.sellTodayRoe ?? 0) + this.getSellTodayRoe(item);
        acc.consultantCommission += this.getConsultantCommission(item);
        acc.agentCommission += this.getAgentCommission(item);
        return acc;
      },
      {
        grossCost: 0,
        discount: 0,
        netCost: 0,
        baseCost: 0,
        profit: 0,
        sell: 0,
        sellTodayRoe: 0,
        consultantCommission: 0,
        agentCommission: 0
      }
    );
  }

  private getGrossCost(item: any): number {
    return this.toNumber(item?.cost);
  }

  private getDiscount(item: any): number {
    return this.toNumber(item?.costDiscount);
  }

  private getNetCost(item: any): number {
    return this.toNumber(
      item?.baseCostAfterDiscount ??
      item?.baseCostCurrentAfterDiscount ??
      this.getCostWithExchangeRate(item) ??
      item?.cost
    );
  }

  private getBaseCost(item: any): number {
    return this.toNumber(
      item?.baseCostCurrentAfterDiscount ??
      item?.baseCostAfterDiscount ??
      this.getCostWithExchangeRate(item) ??
      item?.cost
    );
  }

  private getProfit(item: any): number {
    const explicitProfit = item?.profit ?? item?.profitCurrent;
    if (explicitProfit != null) {
      return this.toNumber(explicitProfit);
    }

    const sell = this.getSell(item);
    const cost = this.getBaseCost(item);
    return this.toNumber(sell - cost);
  }

  private getSell(item: any): number {
    return this.toNumber(
      item?.priceBeforeDiscount ?? item?.priceCurrentBeforeDiscount ?? item?.price
    );
  }

  /** Sell price using today's ROE (prefers priceCurrentBeforeDiscount) */
  private getSellTodayRoe(item: any): number {
    return this.toNumber(
      item?.priceCurrentBeforeDiscount ?? item?.priceBeforeDiscount ?? item?.price
    );
  }

  private getCostWithExchangeRate(item: any): number | null {
    const cost = this.toNumber(item?.cost);
    const exchangeRate = this.toNumber(
      item?.exchangeRate ?? item?.exchangeRateCurrent ?? 1
    );

    if (cost <= 0) {
      return null;
    }

    const rate = exchangeRate > 0 ? exchangeRate : 1;
    return cost * rate;
  }

  private getConsultantCommission(item: any): number {
    return this.toNumber(
      item?.consultantCommission ?? item?.consultantCommissionCurrent ?? item?.consultantCommissionAmount
    );
  }

  private getAgentCommission(item: any): number {
    return this.toNumber(
      item?.commission ?? item?.commissionCurrent ?? item?.agentCommission ?? item?.agentCommissionAmount
    );
  }

  private toNumber(value: any): number {
    if (value === null || value === undefined) {
      return 0;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    if (typeof value === 'string') {
      const parsed = parseFloat(value.replace(/[^0-9.\-]/g, ''));
      return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
  }

  private toDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return null;
    }
    return date;
  }
  // isReviewDrawerVisible() {
  //   return this.view.mode == 'review';
  // }

  openPaymentModal(quote: any) {
    const dialogRef = this.dialog.open(CapturePaymentComponent, {
      width: '1200px',
      data: quote
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });
  }

  openPaxDetailsModal(quote: any) {
    if (quote?.items?.content) {
      quote.itinerary.items = quote.items;
    }

    const dialogRef = this.dialog.open(ReserveDialogComponent, {
      height: '95vh',
      width: '95vw',
      maxWidth: '95vw',
      data: {
        itinerary: quote.itinerary,
        viewOnly: true
      }
    });
    console.log('Modal data:', this.view);

    dialogRef.afterClosed().subscribe(() => {
      this.init();
    });
  }

  openServiceFeeAdjustmentModal(quote: any) {
    const dialogRef = this.dialog.open(AdjustmentComponent, {
      width: '800px', // Set the width of the modal
      maxWidth: '95vw',
      data: quote
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.adjustment) {
        this.applyAdjustmentToQuote(quote, result.adjustment);
      }
      // reload data)
      this.init();
    });
  }

  openServiceItemDialog(serviceItem: any, itinGuid: string = null, focusMealAndRoomOnly: boolean = false) {
    const dialogRef = this.dialog.open(AddServiceItemDialogComponent, {
      width: '800px', // Set the width of the modal
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: { service: serviceItem, guid: itinGuid, focusMealAndRoomOnly }
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });
  }

  /**
   * Open search-options modal to add/load an itinerary (same as "Add..." in search-itinerary / trips list).
   * Uses the given quote or the first quote in the list for itinerary context.
   */
  openAddOption(quote?: any, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    const itinGuid = quote?.itinerary?.guid ?? this.quotes?.content?.[0]?.itinerary?.guid;
    if (!itinGuid) {
      return;
    }
    this._tfmService.setLocalItinGuid(itinGuid);
    this.dialog.open(GenericModalComponent, {
      data: { type: 'search-options-load' },
      height: '90vh',
      width: '90vw',
      maxWidth: '90vw'
    });
  }

  private applyAdjustmentToQuote(quote: any, adjustment: any): void {
    const deltaRaw = adjustment?.price ?? adjustment?.cost ?? 0;
    const delta = this.toNumber(deltaRaw);
    if (!Number.isFinite(delta)) {
      return;
    }

    const itinerary = quote?.itinerary;
    if (!itinerary) {
      return;
    }

    const currentTotal = this.toNumber(itinerary.total);
    const newTotal = currentTotal + delta;
    itinerary.total = newTotal;

    const paid = this.toNumber(itinerary.paid);
    const currentBalance = Number.isFinite(this.toNumber(itinerary.balanceCurrent))
      ? this.toNumber(itinerary.balanceCurrent)
      : this.toNumber(itinerary.balance);
    const baseBalance = Number.isFinite(currentBalance) ? currentBalance : (currentTotal - paid);
    const newBalance = baseBalance + delta;
    itinerary.balanceCurrent = newBalance;
    itinerary.balance = newBalance;

    this._cd.detectChanges();
  }
  openCommissionchangeDialog(quote: any) {
    const dialogRef = this.dialog.open(CommissionchangeDialogComponent, {
      width: '800px', // Set the width of the modal
      maxWidth: '95vw',
      data: quote
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });
  }
  opencancelServiceItemDialog(quote: any) {
    const dialogRef = this.dialog.open(ServiceItemCancelComponent, {
      width: '500px', // Set the width of the modal
      maxWidth: '95vw',
      data: quote

    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });
  }
  openRemoveServiceItemDialog(quote: any) {
    const dialogRef = this.dialog.open(ServiceItemRemoveComponent, {
      width: '500px', // Set the width of the modal
      maxWidth: '95vw',
      data: quote
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });

  }
  openCaptureConfirmationDialog(quote: any) {
    const dialogRef = this.dialog.open(CaptureConfirmationComponent, {
      width: '500px', // Set the width of the modal
      maxWidth: '95vw',
      data: quote
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data)
      this.init();
    });
  }
  openReserveModal(quote: any) {
    // Ensure items are attached to itinerary before opening modal
    if (quote.items?.content) {
      quote.itinerary.items = quote.items; // Attach items to itinerary
    }

    const dialogRef = this.dialog.open(ReserveDialogComponent, {
      height: '95vh',
      width: '95vw',
      maxWidth: '95vw',
      data: {
        itinerary: quote.itinerary // Now includes items
      }
    });

    const instance = dialogRef.componentInstance;
    // Subscribe to process completion (independent of dialog close)
    instance.prebookCompleted$.subscribe((success) => {
      if (success) {
        this.refreshCart.emit();
      }
    });


  }

  openBookModal(quote: any) {
    const dialogRef = this.dialog.open(BookconfirmationmodalComponent, {
      width: '400px',
      data: {
        quote
      }
    });

    const instance = dialogRef.componentInstance;
    // Subscribe to process completion (independent of dialog close)
    instance.bookCompleted$.subscribe((success) => {
      if (success) {
        this.refreshCart.emit();
      }
    });
  }
  openUnReservemodal(quote: any) {
    const dialogRef = this.dialog.open(UnreservebookingmodalComponent, {
      width: '400px',
      data: {
        quote
      }
    });

    const instance = dialogRef.componentInstance;
    // Subscribe to process completion (independent of dialog close)
    instance.UnprebookCompleted$.subscribe((success) => {
      if (success) {
        this.refreshCart.emit();
      }
    });

  }

  public getItemsFromPoint(point) {
    return this._tfmCartService.getItemsFromPoint(point);
  }

  public searchService(point, type = 'hotel') {
    // this._tfmService.log("searchService", point);
    this.openModal(point, type);
  }

  private isAccommodationItem(item: any): boolean {
    if (!item || item.searchType !== 1) {
      return false;
    }

    const token = typeof item.searchResultOptionToken === 'string'
      ? item.searchResultOptionToken.trim().toLowerCase()
      : '';

    return token !== 'custom';
  }

  private async getQuoteItems(quote: any): Promise<any[]> {
    let items = quote?.items?.content || [];

    if (items.length === 0 && quote?.itinerary?.guid) {
      try {
        const res = await firstValueFrom(
          this._tfmService.getItinItems(quote.itinerary.guid)
        );
        quote.items = res;
        items = res?.content || [];
      } catch (error) {
        this._tfmService.log('Failed to load itinerary items', error);
      }
    }

    return items;
  }

  private getAccommodationItems(items: any[]): any[] {
    return items.filter((entry) => this.isAccommodationItem(entry));
  }

  getServiceItems(quote: any): any[] {
    const items = quote?.items?.content;
    if (!Array.isArray(items) || items.length === 0) {
      return [];
    }

    const nonAdjustments = items.filter((item) => !this.isAdjustmentItem(item));
    const adjustments = items.filter((item) => this.isAdjustmentItem(item));

    return adjustments.length ? [...nonAdjustments, ...adjustments] : items;
  }

  /** Get unique accommodation supplier IDs from quote items (for Extras/Specials) */
  getAccommodationSupplierIds(quote: any): { supplierId: number; supplierName: string }[] {
    const items = quote?.items?.content || [];
    const seen = new Set<number>();
    const result: { supplierId: number; supplierName: string }[] = [];
    for (const item of items) {
      if (this.isAdjustmentItem(item)) continue;
      const id = item?.supplierID ?? item?.supplierId ?? item?.supplier?.id;
      if (id && !seen.has(id)) {
        seen.add(id);
        result.push({
          supplierId: id,
          supplierName: (item?.supplier || item?.supplierDescription || 'Supplier ' + id).toString()
        });
      }
    }
    return result;
  }

  /** Load extras for a quote - fetches from accommodation suppliers */
  loadQuoteExtras(quote: any): void {
    if (quote.extrasLoaded) return;
    quote.extrasLoaded = true;
    quote.extrasBySupplier = {};
    quote.extrasLoadComplete = false;
    const suppliers = this.getAccommodationSupplierIds(quote);
    if (suppliers.length === 0) {
      quote.extrasLoadComplete = true;
      this._cd.detectChanges();
      return;
    }
    let pending = suppliers.length;
    suppliers.forEach(({ supplierId, supplierName }) => {
      this._tfmService.getSupplierExtrasBySupplierId(supplierId).subscribe(res => {
        const content = res?.content || [];
        quote.extrasBySupplier = quote.extrasBySupplier || {};
        quote.extrasBySupplier[supplierId] = { supplierName, extras: content };
        pending--;
        if (pending === 0) {
          quote.extrasLoadComplete = true;
          this._cd.detectChanges();
        }
      });
    });
  }

  /** Get all extras data for display (grouped by supplier) */
  getQuoteExtrasData(quote: any): { supplierName: string; extras: any[] }[] {
    const bySupplier = quote?.extrasBySupplier || {};
    return Object.keys(bySupplier).map(id => ({
      supplierName: bySupplier[id].supplierName,
      extras: bySupplier[id].extras || []
    })).filter(x => x.extras.length > 0);
  }

  /** Check if quote has any extras loaded */
  hasQuoteExtras(quote: any): boolean {
    const data = this.getQuoteExtrasData(quote);
    return data.some(d => d.extras.length > 0);
  }

  /** Get total extras count for a quote */
  getQuoteExtrasCount(quote: any): number {
    return this.getQuoteExtrasData(quote).reduce((s, d) => s + d.extras.length, 0);
  }

  /** Get all value add text for a single service item (supports includes and bookLineItems structures). */
  getItemValueAdds(item: any): string[] {
    // Skip activity, flight, and transfer items — their description/includes are part of the
    // service itself, not promotional value adds.
    if (this.isActivityItem(item) || this.isFlightItem(item) || this.isTransferItem(item)) {
      return [];
    }

    const values = new Set<string>();
    const visited = new WeakSet<object>();
    const isNonValueAddLine = (line: string): boolean => {
      const normalized = line.replace(/\s+/g, ' ').trim().toLowerCase();
      return (
        /^\d+\s*(people|person|persons|pax|adult|adults)$/.test(normalized) ||
        /^\d+\s*(seat|seats|seater|seaters)$/.test(normalized)
      );
    };
    const add = (text: string) => {
      const normalized = text.replace(/\s+/g, ' ').trim();
      if (normalized.length > 0 && !isNonValueAddLine(normalized)) {
        values.add(normalized);
      }
    };
    const addFromString = (raw: string) => {
      raw
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .forEach(add);
    };
    const extract = (source: any): void => {
      if (source == null) return;
      if (typeof source === 'string') {
        addFromString(source);
        return;
      }
      if (Array.isArray(source)) {
        source.forEach((entry) => extract(entry));
        return;
      }
      if (typeof source === 'object') {
        if (visited.has(source)) return;
        visited.add(source);
        const candidates = [
          source?.includes,
          source?.Includes,
          source?.description,
          source?.Description,
          source?.valueAdd,
          source?.value_add
        ];
        candidates.forEach((candidate) => {
          if (typeof candidate === 'string' && candidate.trim().length > 0) {
            addFromString(candidate);
          }
        });
        const nested = [
          source?.bookLineItems,
          source?.booklineItems,
          source?.book_line_items,
          source?.valueAdds,
          source?.value_adds
        ];
        nested.forEach((entry) => extract(entry));
      }
    };
    extract(item);
    return Array.from(values);
  }

  /** Get value adds count for a quote. */
  getValueAddsCount(quote: any): number {
    let count = 0;

    // Count item-level value adds
    const items = quote?.items?.content || [];
    if (Array.isArray(items) && items.length > 0) {
      count += items.reduce((sum: number, item: any) => sum + this.getItemValueAdds(item).length, 0);
    }

    // Also count itinerary-level value adds (e.g. hotel promotional inclusions)
    const itin = quote?.itinerary;
    if (itin) {
      const valueAdds = itin.promotions?.value_adds || itin.value_adds || itin.valueAdds;
      if (valueAdds && typeof valueAdds === 'object') {
        count += Object.keys(valueAdds).length;
      }
    }

    return count;
  }

  /** Get discount reason lines for a single service item. */
  getItemDiscountReasons(item: any): string[] {
    const candidates = [
      item?.discountReasons,
      item?.DiscountReasons,
      item?.discount_reasons,
      item?.item?.discountReasons,
      item?.item?.DiscountReasons
    ];

    const raw = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    if (!raw) {
      return [];
    }

    return raw
      .split(/\r?\n/)
      .map((line: string) => line.trim())
      .filter((line: string) => line.length > 0);
  }

  /** Get total discount count for a quote. */
  getDiscountsCount(quote: any): number {
    const items = quote?.items?.content || [];
    if (!Array.isArray(items) || items.length === 0) {
      return 0;
    }
    return items.reduce((sum: number, item: any) => sum + this.getItemDiscountReasons(item).length, 0);
  }

  /** Load supplier extras and discounts for a given supplierID (cached, fires once per supplier). */
  private ensureSupplierDataLoaded(supplierId: number): void {
    if (!supplierId || this._supplierDataRequested.has(supplierId)) {
      return;
    }
    this._supplierDataRequested.add(supplierId);

    this._tfmService.getSupplierExtrasBySupplierId(supplierId).subscribe((res: any) => {
      this._supplierExtrasCache.set(supplierId, res?.content || []);
      this._cd.detectChanges();
    });

    this._tfmService.getSupplierDiscountsBySupplierId(supplierId).subscribe((res: any) => {
      this._supplierDiscountsCache.set(supplierId, res?.content || []);
      this._cd.detectChanges();
    });
  }

  /** Get the extra UpgradeCode for a value-add text by matching against the supplier's extras table. */
  getExtraCodeForValueAdd(item: any, valueAddText: string): string | null {
    const supplierId = item?.supplierID || item?.supplierId || item?.supplier_id;
    if (!supplierId) return null;

    this.ensureSupplierDataLoaded(supplierId);

    const extras = this._supplierExtrasCache.get(supplierId);
    if (!extras || extras.length === 0) return null;

    const needle = (valueAddText || '').replace(/<[^>]*>/g, '').trim().toLowerCase();
    if (!needle) return null;

    const match = extras.find((e: any) => {
      const ft = (e.freeText || e.FreeText || '').trim().toLowerCase();
      return ft && (needle.includes(ft) || ft.includes(needle));
    });

    const code = match?.upgradeCode || match?.UpgradeCode || null;
    return code && code.trim().length > 0 ? code.trim() : null;
  }

  /** Get the discount OfferCode for a discount reason text by matching against the supplier's discounts table. */
  getDiscountOfferCode(item: any, reasonText: string): string | null {
    const supplierId = item?.supplierID || item?.supplierId || item?.supplier_id;
    if (!supplierId) return null;

    this.ensureSupplierDataLoaded(supplierId);

    const discounts = this._supplierDiscountsCache.get(supplierId);
    if (!discounts || discounts.length === 0) return null;

    const needle = (reasonText || '').replace(/<[^>]*>/g, '').trim().toLowerCase();
    if (!needle) return null;

    const match = discounts.find((d: any) => {
      const ft = (d.freeText || d.FreeText || '').trim().toLowerCase();
      return ft && (needle.includes(ft) || ft.includes(needle));
    });

    const code = match?.offerCode || match?.OfferCode || null;
    return code && code.trim().length > 0 ? code.trim() : null;
  }

  private getAccommodationServiceLabel(quote: any): string {
    const items = quote?.items?.content || [];
    if (!Array.isArray(items) || items.length === 0) {
      return '';
    }

    const accommodationItems = this.getAccommodationItems(items);
    if (accommodationItems.length === 0) {
      return '';
    }

    const destination = (quote?.itinerary?.destinationHotel || '').toString().trim().toLowerCase();
    let match = accommodationItems.find((item) => {
      const supplier = (item?.supplier || '').toString().trim().toLowerCase();
      return supplier && destination && supplier === destination;
    });

    if (!match) {
      match = accommodationItems[0];
    }

    return this.getServiceLabel(match);
  }

  getDestinationLabel(quote: any): string {
    const itinerary = quote?.itinerary;
    const candidates = [
      itinerary?.destinationHotel,
      itinerary?.hotelName,
      itinerary?.destination,
      itinerary?.destinationName,
      itinerary?.destinationCity,
      itinerary?.destinationLocation,
      itinerary?.location,
      itinerary?.to
    ];

    const directMatch = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    if (directMatch) {
      return directMatch.trim();
    }

    const items = quote?.items?.content || [];
    const accommodationItems = this.getAccommodationItems(items);
    const item = accommodationItems[0] || items[0];
    if (!item) {
      return '';
    }

    return (
      this.getLocationFromItem(item) ||
      this.getServiceLabel(item) ||
      ''
    );
  }

  getRoomTypeLabel(quote: any): string {
    const accommodationLabel = this.getAccommodationServiceLabel(quote);
    if (accommodationLabel) {
      return accommodationLabel;
    }

    const itinerary = quote?.itinerary;
    const fallback = itinerary?.roomTypeName || itinerary?.roomType?.name || itinerary?.roomType;
    return typeof fallback === 'string' ? fallback : '';
  }

  /** Meal plan (basis) for quote - from first accommodation item. */
  getMealPlanLabel(quote: any): string {
    const items = quote?.items?.content || [];
    const accommodationItems = this.getAccommodationItems(items);
    if (accommodationItems.length === 0) return '';
    return this.getMealPlanLabelForItem(accommodationItems[0]);
  }

  /** Meal plan (basis) for a single service item. */
  getMealPlanLabelForItem(item: any): string {
    if (!item) return '';
    const basis = item?.basis ?? item?.item?.basis ?? '';
    return typeof basis === 'string' ? basis.trim() : '';
  }

  /** Whether the service item is accommodation (for showing meal/room columns and edit action). */
  isAccommodationRow(item: any): boolean {
    return this.isAccommodationItem(item);
  }

  /** Open edit dialog for meal plan and room type. Uses given item or first accommodation item of the quote. */
  openEditMealPlanAndRoomType(quote: any, item?: any): void {
    if (!quote?.itinerary?.guid) return;
    let accommodationItem: any = null;
    if (item && this.isAccommodationItem(item)) {
      accommodationItem = item;
    } else {
      const items = quote?.items?.content || [];
      const accommodationItems = this.getAccommodationItems(items);
      accommodationItem = accommodationItems.length > 0 ? accommodationItems[0] : null;
    }
    if (accommodationItem) {
      this.openServiceItemDialog(accommodationItem, quote.itinerary.guid, true);
    }
  }

  private normalizeChannelName(value: any): string {
    return (value ?? '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private isRoeDetailChannel(value: any): boolean {
    const normalized = this.normalizeChannelName(value);
    return this.roeDetailChannels.has(normalized);
  }

  private resolveRoeCostVisibility(): void {
    let localName = '';
    if (typeof localStorage !== 'undefined') {
      localName = localStorage.getItem('siteName') || '';
    }

    if (this.isRoeDetailChannel(localName)) {
      this.showRoeCostDetails = true;
      return;
    }

    this._tfmService
      .getSite()
      .then((site) => {
        const siteName = site?.name || site?.code || '';
        this.showRoeCostDetails = this.isRoeDetailChannel(siteName);
        this._cd.detectChanges();
      })
      .catch(() => {
        this.showRoeCostDetails = false;
      });
  }

  getQuoteDateRange(quote: any): { start: Date | null; end: Date | null } {
    const itinerary = quote?.itinerary;
    const start = this.toDate(
      itinerary?.departDate ??
      itinerary?.departureDate ??
      itinerary?.startDate ??
      itinerary?.start
    );
    const end = this.toDate(
      itinerary?.returnDate ??
      itinerary?.dateTo ??
      itinerary?.endDate ??
      itinerary?.end
    );

    return { start, end };
  }

  private getLocationFromItem(item: any): string | null {
    const candidates = [item?.to, item?.supplier, item?.title];
    const location = candidates.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );

    return location ? location.trim() : null;
  }

  private getDateRangeFromItem(item: any, quote: any): { start?: any; end?: any } {
    return {
      start: item?.start ?? item?.date ?? quote?.itinerary?.departDate,
      end: item?.end ?? item?.dateTo ?? quote?.itinerary?.returnDate,
    };
  }

  private async resolveActivitySearchContext(
    quote: any,
    item: any
  ): Promise<{ destination: string; start?: any; end?: any } | null> {
    let items: any[] = [];

    if (quote) {
      items = await this.getQuoteItems(quote);
    }

    const accommodationItems = this.getAccommodationItems(items);
    let accommodationItem = this.isAccommodationItem(item) ? item : null;

    if (!accommodationItem) {
      if (accommodationItems.length === 1) {
        accommodationItem = accommodationItems[0];
      } else if (accommodationItems.length > 1) {
        const dialogRef = this.dialog.open(ActivityAccommodationDialogComponent, {
          data: { items: accommodationItems },
          width: '520px',
          maxWidth: '95vw'
        });
        accommodationItem = await firstValueFrom(dialogRef.afterClosed());
        if (!accommodationItem) {
          this.view.activitySelectionCancelled = true;
          return null;
        }
      }
    }

    const destination = this.getLocationFromItem(accommodationItem) ||
      this.getLocationFromItem(item) ||
      this.getLocationFromItem({
        to: quote?.itinerary?.destination,
        supplier: quote?.itinerary?.destinationHotel
      });

    if (!destination) {
      return null;
    }

    const dateSource = accommodationItem || item;
    const dateRange = this.getDateRangeFromItem(dateSource, quote);

    return {
      destination,
      start: dateRange.start,
      end: dateRange.end
    };
  }

  private buildActivitySearch(baseSearch: any, quote: any, start: any, end: any): any {
    const search = baseSearch
      ? {
        ...baseSearch,
        pax: { ...(baseSearch.pax || {}) },
        occupancy: [...(baseSearch.occupancy || [])]
      }
      : {
        pax: {},
        occupancy: []
      };

    const paxOverride = this.getItineraryPax(quote);

    if (paxOverride) {
      search.pax.adult = paxOverride.adult;
      search.pax.teen = paxOverride.teen;
      search.pax.child = paxOverride.child;
      search.pax.infant = paxOverride.infant;
      search.pax.total = paxOverride.total;
    }

    const hasPax = search.pax && ['adult', 'teen', 'child', 'infant'].some(
      (key) => typeof search.pax[key] === 'number'
    );

    if (!hasPax && quote?.itinerary && !paxOverride) {
      search.pax.adult = quote.itinerary.adults;
      search.pax.teen = quote.itinerary.teens;
      search.pax.child = quote.itinerary.children;
      search.pax.infant = quote.itinerary.infants;
    }

    if (start) {
      search.dateFrom = start;
    }
    if (end) {
      search.dateTo = end;
    }

    const occupancySeed = Array.isArray(search.occupancy) ? search.occupancy[0] : null;
    const hasOccupancySeed = occupancySeed && typeof occupancySeed === 'object';

    if (!hasPax && hasOccupancySeed && !paxOverride) {
      search.pax.adult = this.normalizePaxCount(occupancySeed.adultCount);
      search.pax.teen = this.normalizePaxCount(occupancySeed.teenCount);
      search.pax.child = this.normalizePaxCount(occupancySeed.childCount);
      search.pax.infant = this.normalizePaxCount(occupancySeed.infantCount);
    }

    const adultCount = this.normalizePaxCount(search.pax.adult);
    const teenCount = this.normalizePaxCount(search.pax.teen);
    const childCount = this.normalizePaxCount(search.pax.child);
    const infantCount = this.normalizePaxCount(search.pax.infant);
    const childAges = search.pax.childAges ?? occupancySeed?.childAges;

    search.pax.adult = adultCount;
    search.pax.teen = teenCount;
    search.pax.child = childCount;
    search.pax.infant = infantCount;
    search.pax.total = adultCount + teenCount + childCount + infantCount;

    if (paxOverride || !search.occupancy || search.occupancy.length === 0) {
      search.occupancy = [{
        adultCount,
        teenCount,
        childCount,
        infantCount,
        childAges
      }];
    }

    return search;
  }

  public async openModal(item, type, quote = null, settings = null) {
    let dialogTrip = this.view.trip;
    let dialogPoint = item;
    let dialogSearch = this._tfmCartService.getSearch() ?? this.view.search;

    if (type == 'activity') {
      const context = await this.resolveActivitySearchContext(quote, item);

      if (!context) {
        if (this.view.activitySelectionCancelled) {
          this.view.activitySelectionCancelled = false;
          return;
        }
        this._tfmService.log('Missing destination for activity search', quote);
        this.dialog.open(ConfirmationDialogComponent, {
          data: {
            title: 'Nothing found',
            message: 'We could not determine a location for activities. Please try another option.',
            showClose: true,
            showViewQuotes: false,
            showNewQuote: false
          }
        });
        return;
      }

      dialogSearch = this.buildActivitySearch(dialogSearch, quote, context.start, context.end);
      this.view.search = dialogSearch;
      this._tfmCartService.updateSearch(dialogSearch);

      const activityStart = context.start || quote?.itinerary?.departDate;
      const activityEnd = context.end || quote?.itinerary?.returnDate;

      if (!dialogPoint || !dialogPoint.place_id) {
        const destination = context.destination;

        try {
          const resCity = await firstValueFrom(
            this._tfmService.getPlaces(
              destination.toLowerCase(),
              'cities'
            )
          );
          const predictions = resCity?.content?.predictions ?? [];

          if (predictions.length === 0) {
            this.dialog.open(ConfirmationDialogComponent, {
              data: {
                title: 'Nothing found',
                message: `We could not find a location for "${destination}". Try another destination.`,
                showClose: true,
                showViewQuotes: false,
                showNewQuote: false
              }
            });
            return;
          }

          dialogPoint = {
            index: 0,
            type: 'hotel',
            title: destination,
            place_id: predictions[0].place_id, //'ChIJaZQ_ZlndTxkRYWDYnFLM-qY',
            date: activityStart,
            dateTo: activityEnd
          };
        } catch (error) {
          this._tfmService.log('Failed to load activity locations', error);
          this.dialog.open(ConfirmationDialogComponent, {
            data: {
              title: 'Search failed',
              message: 'Unable to load locations for activities. Please try again.',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            }
          });
          return;
        }
      }
      else {
        dialogPoint = {
          ...dialogPoint,
          date: activityStart ?? dialogPoint.date,
          dateTo: activityEnd ?? dialogPoint.dateTo
        };
      }

      dialogTrip = { points: [dialogPoint] };
    }

    var data: any = {
      data: { search: dialogSearch, trip: dialogTrip, point: dialogPoint, type: type, itin: quote || this.view.itin },
      height: '95vh',
      width: '95vw',
      maxWidth: '95vw'
    };

    if (settings) {
      data.isAgent = settings.isAgent;
      data.sid = settings.sid;
    }

    console.log("DATA", data);

    if (type == 'hotel') {
      let dialogRef = this.dialog.open(StayListDialogComponent, data);

      dialogRef.afterClosed().subscribe(result => { });
    }
    else if (type == 'activity') {
      let dialogRef = this.dialog.open(ActivityListDialogComponent, data);

      dialogRef.afterClosed().subscribe(async result => {
        if (quote && quote.itinerary && quote.itinerary.id) {
          await this._tfmCartService.commitCartToItin(quote.itinerary.id);

          this.dialog.open(ConfirmationDialogComponent, {
            data: {
              title: 'Activity added',
              message: 'The service has been updated',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            }
          });

          this.init();
        }
      });
    }
    else if (type == 'transfer') {
      let dialogRef = this.dialog.open(TransferListDialogComponent, data);

      dialogRef.afterClosed().subscribe(result => { });
    }
    else if (type == 'quote') {
      data.height = '95vh';

      let dialogRef = this.dialog.open(QuoteViewDialogComponent, data);

      dialogRef.afterClosed().subscribe(result => {
      });
    }
    else if (type == 'invoice') {
      data.height = '95vh';

      let dialogRef = this.dialog.open(InvoiceViewDialogComponent, data);

      dialogRef.afterClosed().subscribe(result => {
      });
    }
    else if (type == 'whatsapp') {
      data.height = '35vh';
      data.width = '65vh';

      let dialogRef = this.dialog.open(WhatsappViewDialogComponent, data);

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  getItinItems(quote) {
    // This is the testing
    // quote.items = {
    //   content: [{
    //     type: 'activity',
    //     service: 'Test Activity',
    //     supplier: 'Test Supplier',
    //     start: new Date(),
    //     end: new Date(),
    //     adultCount: 2,
    //     price: 1000
    //   }]
    // };
    this._tfmService.getItinItems(quote.itinerary.guid).subscribe(res => {
      quote.items = res;
      console.log('items', quote)

      this._cd.detectChanges();
    });

    // this._tfmService.log("QUOTE ITEMS", quote.itinerary.option, quote);
  }
  public getPointFromIndex(index) {
    if (this.view.trip.points.filter(x => x.index == index).length > 0)
      return this.view.trip.points.filter(x => x.index == index)[0];

    return null;
  }
  getItinQuotes(referenceID) {
    if (referenceID) {
      this._tfmService.getItinOptions(referenceID).subscribe(resOptions => {
        resOptions.content.sort((a, b) => a.itinerary.option - b.itinerary.option);
        this.view.quotes = resOptions;

        this._tfmService.log("QUOTE OPTIONS", this.view);
        //this.queryStringGuid = resOptions.content.map(item => `guids=${item.itinerary.guid}`).join("&");
        this.view.quotesAll = resOptions.content.map(item => `guids=${item.itinerary.guid}`).join("&");

        if (this.view.quotes) {
          this.view.quotes._links.forEach(l => {
            l.href = l.href.replace("http://", "https://");
          });
          this.view.quotes.content.forEach(quote => this.getItinItems(quote));
        }

        this._cd.detectChanges();
      });
    }
  }
}

